<template>
  <v-col class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-account-search"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-row class="white mr-4 rounded-lg pa-4">
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="careerDetail.name"
                    filled
                    label="Vacancy"
                    placeholder="Enter vacancy"
                    @keyup="onKeyUp"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="careerDetail.slug"
                    filled
                    label="Slug"
                    placeholder="Nhập Slug"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="careerDetail.short_description"
                    filled
                    label="Short description"
                    placeholder="Enter short description"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <div class="mb-4">Description</div>
                <ck-content class="ck-content" :content="careerDetail.description"
                            @getData="value => careerDetail.description = value"></ck-content>
              </v-col>
              <v-col cols="12">
                <v-select
                    chips
                    v-model="list_position_id"
                    :items="list_positions"
                    item-text="name"
                    item-value="id"
                    label="Kinh nghiệm"
                    multiple
                    outlined
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="careerDetail.upto_salary"
                    filled
                    label="Lương"
                    placeholder="Nhập lương"
                ></v-text-field>
              </v-col>
            </v-col>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="careerDetail.name_vi"
                    filled
                    label="Vị trí tuyển dụng"
                    placeholder="Nhập vị trí tuyển dụng"
                ></v-text-field>
              </v-col>
              <v-col cols="12" style="margin-bottom: 86px"></v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="careerDetail.short_description_vi"
                    filled
                    label="Miêu tả ngắn"
                    placeholder="Nhập miêu tả ngắn"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <div class="mb-4">Miêu tả</div>
                <ck-content class="ck-content" :content="careerDetail.description_vi"
                            @getData="value => careerDetail.description_vi = value"></ck-content>
              </v-col>
              <v-col cols="12">
                <v-select
                    chips
                    v-model="careerDetail.work_time"
                    :items="work_time_info"
                    item-text="name"
                    item-value="value"
                    outlined
                    label="Hình thức làm việc"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="careerDetail.address"
                    filled
                    label="Địa chỉ"
                    placeholder="Nhập địa chỉ "
                ></v-text-field>
              </v-col>
            </v-col>
            <v-col class="d-flex justify-center" cols="12">
              <v-btn class="px-10" color="primary" elevation="6" width="180" @click="save">LƯU</v-btn>
            </v-col>
          </v-row>

        </v-col>
      </v-row>


    </v-container>
  </v-col>
</template>

<script>
import CkContent from "@/components/ck-content"
import {mapGetters} from "vuex";
import {GET_DETAIL_CAREER, UPDATE_CAREER} from "@/store/modules/career";
import {GET_LIST_POSITION} from "@/store/modules/position";
import validateSlug from "@/mixins/validateSlug";

export default {
  name: "Edit_carrer",
  mixins: [validateSlug],
  components: {
    CkContent,
  },
  data() {
    return {
      page: "Sửa career",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách Carrers",
          disabled: true,
        },
        {
          text: "Sửa career",
          disabled: false,
        },
      ],
      work_time_info: [
        {
          name: 'Fulltime',
          value: 1
        },
        {
          name: 'Partime',
          value: 2
        }
      ],
      list_positions: [],
      list_position_id: [],

    }
  },
  computed: {
    ...mapGetters({
      careerDetail: "careerDetail",
      position: "position",
    }),
  },
  async created() {
    await this.$store.dispatch(`${GET_DETAIL_CAREER}`, this.$route.params.id);
    await this.$store.dispatch(`${GET_LIST_POSITION}`);
    if (this.careerDetail && this.careerDetail.position_carrers) {
      this.careerDetail.position_carrers.forEach((el) => {
        this.list_position_id.push(el.id);
      });
    }
  },
  watch: {
    position(val) {
      if (val) {
        const _this = this
        val.forEach(el => {
          _this.list_positions.push({
            id: el.id,
            name: el.name,
          })
        })
      }
    },
  },
  methods: {
    onKeyUp(value){
      this.careerDetail.slug = this.sanitizeTitle(value.target.value)
    },
    async save() {
      this.careerDetail.position_carrers = []
      const _this = this;
      //list tags
      this.list_position_id.forEach(id => {
        let tag = _this.list_positions.find(el => el.id == id)
        _this.careerDetail.position_carrers.push({
          id: tag.id,
          name: tag.name,
        })
      })
      let data = {
        id: this.$route.params.id,
        name: this.careerDetail.name,
        name_vi: this.careerDetail.name_vi,
        description: this.careerDetail.description,
        description_vi: this.careerDetail.description_vi,
        upto_salary: this.careerDetail.upto_salary,
        work_time: this.careerDetail.work_time,
        position_tags: this.careerDetail.position_carrers,
        address: this.careerDetail.address,
        slug: this.careerDetail.slug,
        short_description: this.careerDetail.short_description,
        short_description_vi: this.careerDetail.short_description_vi
      }
      await this.$store.dispatch(`${UPDATE_CAREER}`, data).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/career_management/career')
        } else {
          alert(data.data.errors)
        }
      });
    }
  }
}
</script>

<style scoped>

</style>